/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable @nx/enforce-module-boundaries */
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';
import $http from '../services/api';

export type RegistrationResult = 'success' | 'userNotFound' | 'invalidToken';

@Module({ namespaced: true })
export default class App extends VuexModule {
  public registrationRes: RegistrationResult | null = null;

  public tokenRequestResult: boolean | null = null;

  @Mutation
  setConfirmResult(registrationRes: RegistrationResult) {
    this.registrationRes = registrationRes;
  }

  @Mutation
  setTokenRequestResult(tokenRequestResult: boolean) {
    this.tokenRequestResult = tokenRequestResult;
  }

  @Action({ commit: 'setConfirmResult' })
  async confirmAppRegistration(token: string) {
    return await $http
      .get('appusers/registration/confirm/' + token)
      .then((resp) => 'success')
      .catch((err) => {
        if (err.response.status === 404) {
          return 'userNotFound';
        } else {
          return 'invalidToken';
        }
      });
  }

  @Action({ commit: 'setTokenRequestResult' })
  async requestnewtoken(token: string) {
    return await $http
      .get('appusers/registration/requestnewtoken/' + token)
      .then((resp) => true)
      .catch((err) => false);
  }
}
